import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1688bbc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialogHeader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blueBar" }, null, -1))
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "dialog-footer" }

import {transformI18n} from '@/langs/i18n';
import {
  ElMessage,
  FormInstance,
  FormRules,
} from 'element-plus';
import {
  computed,
  nextTick,
  reactive,
  ref, watch,
} from 'vue';
import {userUpdate} from '@/api/user';
import {debounce} from '@/utils';

type VoidNoop = (arg0?: Error) => void

interface stateType {
  oldPassword: string,
  password: string,
  confirmPassword: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'editPasswordDialog',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props;


const loading = ref(false);



const ruleFormRef = ref<FormInstance>();

const defaultForm = {
  oldPassword: '',
  password: '',
  confirmPassword: '',
};

const form = reactive<stateType>({
  ...defaultForm,
});

const validateOldPassword = (rule: any, value: string, callback: VoidNoop) => {
  if (value === '') {
    callback(new Error(transformI18n('user.oldPasswordReg')));
    return;
  }
  callback();
};

const validatePassword = (rule: any, value: string, callback: VoidNoop) => {
  if (value === '') {
    callback(new Error(transformI18n('user.passwordReg')));
    return;
  }
  if (form.oldPassword === value) {
    callback(new Error(transformI18n('user.oldPasswordMatchReg')));
    return;
  }
  if (value.length < 6) {
    callback(new Error(transformI18n('user.passwordCorrectReg')));
    return;
  }
  callback();
};

const validateConfirmPassword = (rule: any, value: string, callback: VoidNoop) => {
  if (value === '') {
    callback(new Error(transformI18n('user.confirmPasswordReg')));
    return;
  }
  if (form.password !== form.confirmPassword) {
    callback(new Error(transformI18n('user.confirmPasswordCorrectReg')));
    return;
  }
  callback();
};

const rules = computed(() => reactive<FormRules>({
  oldPassword: [{required: true, validator: validateOldPassword, trigger: 'change'}],
  password: [{required: true, validator: validatePassword, trigger: 'change'}],
  confirmPassword: [{required: true, validator: validateConfirmPassword, trigger: 'change'}],
}));

const handlerClose = () => {
  updateVisible();
};

const updateVisible = () => {
  emit('update:visible', false);
};

watch(() => props.visible, (newValue) => {
  if (newValue) {
    Object.assign(form, {
      ...defaultForm,
    });
    setTimeout(() => {
      ruleFormRef.value?.clearValidate();
    });
  }
});

const handleSure = debounce(() => {
  ruleFormRef.value?.validate((valid?: boolean) => {
    if (valid) {
      updateUser();
    }
  });
}, 500, true);

const updateUser = async () => {
  const {
    oldPassword,
    password,
  } = form;
  loading.value = true;
  try {
    await userUpdate({
      id: 0,
      oldPassword,
      password,
    });
    ElMessage.success(transformI18n('common.editSuccess'));
    updateVisible();
  } catch {
    // do nothing.
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "onUpdate:visible": updateVisible,
    onClose: handlerClose
  }, {
    header: _withCtx(({titleId, titleClass}) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, _toDisplayString(_unref(transformI18n)('user.editPassword')), 11, _hoisted_3)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_el_button, { onClick: updateVisible }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(transformI18n)('common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: _unref(handleSure)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(transformI18n)('common.sure')), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: form,
        rules: _unref(rules),
        size: "default",
        "label-position": "right",
        "label-width": "180px",
        style: {"width":"80%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(transformI18n)('user.oldPassword'),
            prop: "oldPassword"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.oldPassword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.oldPassword) = $event)),
                modelModifiers: { trim: true },
                type: "password",
                autocomplete: "new-password",
                clearable: "",
                tabindex: "5",
                maxlength: "30"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(transformI18n)('user.password'),
            prop: "password"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
                modelModifiers: { trim: true },
                type: "password",
                autocomplete: "new-password",
                clearable: "",
                tabindex: "5",
                maxlength: "30"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(transformI18n)('user.confirmPassword'),
            prop: "confirmPassword"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.confirmPassword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.confirmPassword) = $event)),
                modelModifiers: { trim: true },
                type: "password",
                autocomplete: "new-password",
                clearable: "",
                tabindex: "6",
                maxlength: "30"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})